import {
    cleanAmplitudeParamsFromUrl,
    IAmplitudeExperimentVariants,
    initAmplitude,
    initAmplitudeCrossDomainTracking,
    resolveFeatureFlags,
    setResolvedFeatureFlags,
    waitForAmplitudeInitialization
} from "@pg-mono/amplitude";

import {amplitudeApiKey, amplitudeDeploymentKey, amplitudeEnvironment, kmUrl} from "../common/app/read_rp_environment_variables";
import {rpFeatureFlags} from "../common/feature_flags/rp_feature_flags";

declare global {
    interface Window {
        __AMPLITUDE_VARIANTS__?: IAmplitudeExperimentVariants;
    }
}

export const rpAmplitudeInit = (userId?: string) => {
    const initialVariants = window.__AMPLITUDE_VARIANTS__;
    delete window.__AMPLITUDE_VARIANTS__;

    if (initialVariants) {
        setResolvedFeatureFlags(resolveFeatureFlags(rpFeatureFlags, initialVariants));
    }

    initAmplitude({
        amplitudeApiKey,
        environment: amplitudeEnvironment,
        deploymentKey: amplitudeDeploymentKey,
        initialVariants,
        userId
    });

    initAmplitudeCrossDomainTracking([new URL(kmUrl).hostname]);
    void waitForAmplitudeInitialization().then(() => cleanAmplitudeParamsFromUrl());
};
import {
    cleanAmplitudeParamsFromUrl,
    IAmplitudeExperimentVariants,
    initAmplitude,
    initAmplitudeCrossDomainTracking,
    resolveFeatureFlags,
    setResolvedFeatureFlags,
    waitForAmplitudeInitialization
} from "@pg-mono/amplitude";

import {amplitudeApiKey, amplitudeDeploymentKey, amplitudeEnvironment, kmUrl} from "../common/app/read_rp_environment_variables";
import {rpFeatureFlags} from "../common/feature_flags/rp_feature_flags";

declare global {
    interface Window {
        __AMPLITUDE_VARIANTS__?: IAmplitudeExperimentVariants;
    }
}

export const rpAmplitudeInit = (userId?: string) => {
    const initialVariants = window.__AMPLITUDE_VARIANTS__;
    delete window.__AMPLITUDE_VARIANTS__;

    if (initialVariants) {
        setResolvedFeatureFlags(resolveFeatureFlags(rpFeatureFlags, initialVariants));
    }

    initAmplitude({
        amplitudeApiKey,
        environment: amplitudeEnvironment,
        deploymentKey: amplitudeDeploymentKey,
        initialVariants,
        userId
    });

    initAmplitudeCrossDomainTracking([new URL(kmUrl).hostname]);
    void waitForAmplitudeInitialization().then(() => cleanAmplitudeParamsFromUrl());
};
